import {NgModule} from '@angular/core';
import { FiltroPipe } from './filtro/filtro';

@NgModule({
  declarations: [FiltroPipe],
  imports: [],
  exports: [FiltroPipe]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts